import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';

import choque from '@assets/images/moment1.svg';
import vehiculo from '@assets/images/moment2.svg';
import robo from '@assets/images/moment3.svg';
import lastimar from '@assets/images/moment4.svg';
import hospital from '@assets/images/moment5.svg';
import ayuda from '@assets/images/moment6.svg';

const moments = [
  { img: choque, text: 'Por si chocas o te chocan' },
  { img: vehiculo, text: 'Por si dañas algo con tu vehículo' },
  { img: robo, text: 'Por si te roban tu vehículo' },
  { img: lastimar, text: 'Por si lastimas a alguien con tu vehículo' },
  {
    img: hospital,
    text: 'Por si tú o alguno de tus acompañantes debe ir al hospital por un accidente ',
  },
  { img: ayuda, text: 'Por si necesitas ayuda vial, legal  o médica' },
];

export const EnsuranceMoments = () => {
  const { breakpoints } = useTheme();

  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  return (
    <Box
      sx={{ backgroundColor: '#F2FAFC', paddingBottom: '40px' }}
      zIndex={9999}
    >
      <Typography
        component="h2"
        sx={{
          paddingTop: '40px',
          textAlign: 'center',
          fontSize: isMobile ? '20px' : isTablet ? '22px' : '28px',
          fontWeight: '900',
          width: isMobile ? '350px' : 'inherit',
          margin: isMobile ? 'auto' : 'inherit',
        }}
      >
        Momentos en los que un seguro te puede echar la mano
      </Typography>
      <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
        <Grid
          item
          container
          sx={{
            width: 1050,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {moments.map((item, indx) => (
            <Grid
              key={item.img}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 350,
              }}
              item
            >
              <Box
                component={'img'}
                loading='lazy'
                src={item.img}
                sx={{
                  width: 90,
                  height: 90,
                }}
                alt={item.text}
                marginTop="20px"
                marginBottom={'20px'}
              />
              <Typography
                sx={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  paddingLeft: 2,
                  paddingRight: 2,
                }}
              >
                {item.text}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};
